import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import { useHistory } from "react-router-dom";
import { Dropdown } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import Loader from "../../components/Dailogs/Loader";
import search from "../../assets/icons/search.svg";
import { Col, Row } from "react-bootstrap";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchRoleModuleAccess,
  FetchUsersSchedule,
  UpdateUsersLogTimer,
  UpdateUsersTimerOff,
} from "../../redux/actions/action";
import Filters from "../../utils/addMember/Filters";
import moment from "moment";
import arrow from "../../assets/icons/down arrow.svg";
import { Modal } from "antd";
import xIcon from "../../assets/icons/x-circle.svg";
import { TimeOffEntryPopover } from "../../utils/addMember/helpers";

const Schedule = () => {
  const roleid = window.localStorage.getItem("roleid");
  const initials = window.localStorage.getItem("initials");

  const history = useHistory();
  const dispatch = useDispatch();
  const FetchUsersByScheduleRes = useSelector(
    (state) => state.user.FetchUsersSchedule,
  );
  const FetchUserData = useSelector(
    (state) => state.user.fetchActiveUser?.data,
  );
  const AddUserLogTimerRes = useSelector((state) => state.user.AddUserLogTimer);
  const UpdateUserTimeOffRes = useSelector(
    (state) => state.user.UpdateUserTimeOff,
  );
  const [query, setQuery] = useState("");
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [fetchTransCoWorkersList, setFetchTransCoWorkersList] = useState({});
  const t = (key) => fetchTransCoWorkersList?.[key] || "";
  const [filteredList, setFilteredList] = useState([]);
  const [memberListData, setMemberListData] = useState([]);
  const [allDays, setAllDays] = useState([]);
  const [weekNumber, setWeekNumber] = useState(null); // State to store week number

  const startWeek = moment().startOf("isoWeek").format();
  const headerDate = moment(startWeek).format();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState(0);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [openTimeOff, setOpenTimeOff] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [index, setIndex] = useState(null);
  const [timeOffEntries, setTimeOffEntries] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const addNewEntry = (newEntry) => {
    setTimeOffEntries([newEntry]);
    const payload = {
      usersTimeOff: [
        {
          userid: selectedUserId,
          type: newEntry.type,
          startingDate: moment(newEntry.startingDate, "YYYY-MM-DD") // Use date-only format for the start date
            .endOf("day") // Normalize to the start of the day
            .utc() // Convert to UTC
            .toISOString(),
          lastDay: newEntry.lastDay
            ? moment(newEntry.lastDay, "YYYY-MM-DD") // Use date-only format for the end date
                .endOf("day") // Normalize to the end of the day
                .utc() // Convert to UTC
                .toISOString()
            : moment(newEntry.startingDate, "YYYY-MM-DD")
                .endOf("day") // Default to the end of the same day if no `lastDay`
                .utc() // Convert to UTC
                .toISOString(),
          totalDays: newEntry.lastDay
            ? moment(newEntry.lastDay, "YYYY-MM-DD").diff(
                moment(newEntry.startingDate, "YYYY-MM-DD"),
                "days",
              ) + 1
            : 1,
          percent: newEntry.percent || "",
          status: newEntry.status || "",
          justification: newEntry.justification || "",
          file: newEntry.file || "",
          manager: newEntry.manager || "",
        },
      ],
    };

    setShowLoader(true);
    dispatch(UpdateUsersTimerOff(payload));
  };

  useEffect(() => {
    if (UpdateUserTimeOffRes?.data?.status) {
      setShowLoader(true);
      dispatch(FetchUsersSchedule(weekNumber));
    }
  }, [UpdateUserTimeOffRes]);

  useEffect(() => {
    if (FetchUserData && FetchUserData.length > 0) {
      setSelectedUser(new Array(FetchUserData).fill(false));
    }
  }, [FetchUserData]);
  // Function to open the modal
  const openModal = (dayName, id, val) => {
    setInputValue(val > 0 ? val : 0);
    setIsModalOpen(true);
    setSelectedDay(dayName);
    setSelectedUserId(id);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (FetchUsersByScheduleRes?.data?.status) {
      setShowLoader(false);
      setMemberListData(FetchUsersByScheduleRes?.data?.data);
      setFilteredList(FetchUsersByScheduleRes?.data?.data);
    }
  }, [FetchUsersByScheduleRes]);

  useEffect(() => {
    if (AddUserLogTimerRes?.data?.status) {
      closeModal();
      setShowLoader(true);
      dispatch(FetchUsersSchedule(weekNumber));
    }
  }, [AddUserLogTimerRes]);

  useEffect(() => {
    if (headerDate) {
      setWeekNumber(moment().isoWeek());
    }
  }, [headerDate]);

  useEffect(() => {
    if (weekNumber) {
      setShowLoader(true);
      dispatch(FetchUsersSchedule(weekNumber));
    }
  }, [dispatch, weekNumber]);

  useEffect(() => {
    fetchScreenTranslations("Co-Workers-List").then(setFetchTransCoWorkersList);
    dispatch(FetchRoleModuleAccess(roleid));
  }, [roleid, dispatch]);

  const getCurrentWeek = (startDate) => {
    const weekStart = moment(startDate).startOf("isoWeek");
    return Array.from({ length: 7 }, (_, i) =>
      weekStart.clone().add(i, "days"),
    );
  };

  // Helper function to extract date info
  const getDateInfo = (day) => {
    const dateStr = day._d.toString().split(" ");
    const [dayOfWeek, month, date] = dateStr;
    return { date, dayOfWeek, month };
  };

  // Helper function to check if the day is today
  const isCurrentDay = (date, dayOfWeek, month) => {
    const today = new Date().toString().split(" ");
    return today[2] === date && today[0] === dayOfWeek && today[1] === month;
  };

  // Handle filter submit
  const handleFilterSubmit = (values) => {
    if (values === "all") setFilteredList(memberListData);
    else if (values && values.length > 0) {
      const object = values[0];
      let type = "";

      if (object.hasOwnProperty("jobtypename")) type = "jobtypename";
      else if (object.hasOwnProperty("contractTypeName"))
        type = "contractTypeName";
      else if (object.hasOwnProperty("statusLabel")) type = "statusLabel";

      if (type === "jobtypename") {
        let arr = [];
        for (let key of values) {
          let list = [...memberListData];
          list = list.filter(
            (row) =>
              key.jobtypename === row?.userdetails[0]?.jobid[0]?.function,
          );
          arr = [...arr, ...list];
        }
        setFilteredList(arr);
      } else if (type === "contractTypeName") {
        let arr = [];
        for (let key of values) {
          let list = [...memberListData];
          list = list.filter(
            (row) => key.contractTypeName === row?.userdetails[0]?.contracttype,
          );
          arr = [...arr, ...list];
        }
        setFilteredList(arr);
      } else if (type === "statusLabel") {
        let arr = [];
        for (let key of values) {
          let list = [...memberListData];
          list = list.filter((row) => {
            const activeMember =
              row?.substatus && row?.substatus !== ""
                ? row?.substatus
                : row?.userdetails[0]?.isactive === 1
                  ? "Active"
                  : row?.userdetails[0]?.isactive === 0
                    ? "Non Active"
                    : row?.userdetails[0]?.isactive === 2
                      ? "Pending"
                      : "";
            return activeMember === key.statusLabel;
          });
          arr = [...arr, ...list];
        }
        setFilteredList(arr);
      }
    } else setFilteredList(memberListData);
  };

  const filteredMembers = query
    ? filteredList.filter((member) => {
        const searchText = query.toLowerCase();
        const fullName = `${member.firstname ?? ""} ${
          member.lastname ?? ""
        }`.toLowerCase(); // Concatenate and handle null values

        return (
          member.firstname?.toLowerCase().includes(searchText) || // Match firstname
          member.lastname?.toLowerCase().includes(searchText) || // Match lastname
          fullName.includes(searchText) // Match full name
        );
      })
    : filteredList;

  // Dropdown menu items
  const items = [
    {
      key: "0",
      label: (
        <div onClick={() => history.push("/Teams")}>
          {/* Teams */}
          {t("Teams")}
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={() => history.push("/member-list")}>
          {/* Employees */}
          {t("Employees")}
        </div>
      ),
    },
    {
      key: "2",
      // label: "Vacation Reports"
      label: t("Vacation Reports"),
    },
  ];

  const [currentWeekStart, setCurrentWeekStart] = useState(
    moment().startOf("isoWeek"),
  ); // State to track current week's start

  useEffect(() => {
    setAllDays(getCurrentWeek(currentWeekStart)); // Update allDays whenever currentWeekStart changes
  }, [currentWeekStart]);

  const goToPreviousWeek = () => {
    const previousWeekStart = moment(currentWeekStart).subtract(1, "week");
    setCurrentWeekStart(previousWeekStart); // Update currentWeekStart to previous week's start
    setWeekNumber(previousWeekStart.isoWeek()); // Update the week number
  };

  const goToNextWeek = () => {
    const nextWeekStart = moment(currentWeekStart).add(1, "week");
    setCurrentWeekStart(nextWeekStart); // Update currentWeekStart to next week's start
    setWeekNumber(nextWeekStart.isoWeek()); // Update the week number
  };

  const handleAssignClick = async () => {
    if (inputValue < 1) {
      return;
    }
    const typeVal = weekNumber % 2 === 0 ? "even" : "odd";

    const payload = {
      usersLogtimer: [
        {
          userLogTimerid:
            filteredMembers.filter(
              (data) => data.userid === selectedUserId,
            )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.userLogTimerid ??
            undefined,
          userid: selectedUserId,
          type: typeVal,
          weekNumber: weekNumber.toString(),
          monday:
            selectedDay === "monday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["monday"] ?? ""),
          tuesday:
            selectedDay === "tuesday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["tuesday"] ??
                ""),
          wednesday:
            selectedDay === "wednesday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["wednesday"] ??
                ""),
          thursday:
            selectedDay === "thursday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["thursday"] ??
                ""),
          friday:
            selectedDay === "friday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["friday"] ?? ""),
          saturday:
            selectedDay === "saturday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["saturday"] ??
                ""),
          sunday:
            selectedDay === "sunday"
              ? inputValue
              : (filteredMembers.filter(
                  (data) => data.userid === selectedUserId,
                )?.[0]?.userdetails?.[0]?.usersLogtimer?.[0]?.["sunday"] ?? ""),
        },
      ],
    };
    try {
      setShowLoader(true);
      dispatch(UpdateUsersLogTimer(payload));
      closeModal(); // Close modal after successful operation
    } catch (error) {
      console.error("Error updating log timer:", error);
    }
  };

  return (
    <>
      <Header
        hideSearch={true}
        setQuery={setQuery}
        leftComponent={
          <div className="d-flex align-items-baseline gap-5">
            <div
              className="fw-bold"
              style={{
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Co-Worker */}
              {t("Co-Workers")}
            </div>
            <Dropdown
              trigger={["click"]}
              menu={{ items }}
              open={dropDownOpen}
              onOpenChange={setDropDownOpen}
            >
              <div
                className="fw-bold dropdown col-4 HideForTablet justify-content-between d-flex"
                style={{
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                }}
              >
                <span onClick={() => history.push("/Schedule")}>
                  {/* Schedule */}
                  {t("Schedule")}
                </span>
                {dropDownOpen ? <UpOutlined /> : <DownOutlined />}
              </div>
            </Dropdown>
          </div>
        }
      />

      <div className="parent">
        <div className="member_searchShow" style={{ position: "relative" }}>
          <input
            className="member_search_input_input"
            type="text"
            placeholder="Search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <img className="member_search_input_icon" src={search} alt="Search" />
        </div>
        <div className="outer">
          <Row>
            <Col xs={6} xl={9} className="p-0 align-item-center d-flex">
              <p
                className="fw-bold ps-4 mt-2 d-none ascCoworkerTXTShowHide"
                style={{
                  fontSize: "clamp(20px, 1.354vw, 1.354vw)",
                  color: "#333333",
                }}
              >
                {t("Co-Workers")}
              </p>
              <Filters onSubmit={handleFilterSubmit} alwaysVisible={true} />
            </Col>
            <Col xs={6} xl={3} className="add-col-item pe-0 ">
              <div className="d-flex justify-content-end">
                <div className="buttons-desktop d-flex justify-content-end gap-4">
                  <button
                    type="button"
                    className="canclebtn-add invite-btn-aspect-ratio-mobile-position tablet-width-fixed"
                    onClick={() => history.goBack()}
                  >
                    {/* Cancel */}
                    {t("Cancel")}
                  </button>
                  <button
                    onClick={() => history.push("/Schedule")}
                    type="button"
                    className="invitebtn-add-member invite-btn-aspect-ratio-mobile-position tablet-width-fixed"
                  >
                    {/* Change */}
                    {t("Change")}
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="d-flex flex-column gap-0 w-100 overflow-scroll">
        <div
          className="mb-0 calendar-view-box-schedule-2"
          style={{ minWidth: "1000px" }}
        >
          <div
            style={{ position: "relative" }}
            className="d-flex align-items-center"
          >
            <input
              className="member_search_input_input_schedule"
              type="text"
              // placeholder="Search Worker"
              placeholder={t("Search Worker")}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{
                font: "normal normal normal 12px/17px Manrope",
                letterSpacing: "0px",
                color: "#707070",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
            <img
              className="member_search_input_icon_schedule"
              src={search}
              alt="Search"
            />
          </div>
          <img
            alt=""
            src={arrow}
            style={{
              transform: "rotate(90deg)",
              cursor: "pointer",
              marginLeft: "0.5rem",
            }}
            onClick={goToPreviousWeek}
          />

          <section className="schedule-wrp">
            {allDays.map((day, index) => {
              const { date, dayOfWeek, month } = getDateInfo(day);
              const isToday = isCurrentDay(date, dayOfWeek, month);
              const isNewMonth =
                index === 0 || day.month() !== allDays[index - 1].month();
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      paddingRight: "0.5rem",
                      marginTop: "-2rem",
                    }}
                  >
                    {isNewMonth && day.format("MMM")}
                  </div>
                  <div
                    className="active-date-div"
                    style={{ backgroundColor: isToday ? "" : "#F1F1F1" }}
                  >
                    <p
                      className="mb-0 active-date-top"
                      style={{
                        fontSize: "clamp(14px,0.729vw,0.729vw)",
                        fontWeight: "bold",
                        color: isToday ? "white" : "#333",
                      }}
                    >
                      {date}
                    </p>
                    <p
                      className="mb-0 active-date-bottom"
                      style={{ backgroundColor: isToday ? "" : "#F1F1F1" }}
                    >
                      {dayOfWeek}
                    </p>
                  </div>
                </div>
              );
            })}
          </section>
          <img
            alt=""
            src={arrow}
            style={{
              transform: "rotate(-90deg)",
              cursor: "pointer",
              marginRight: "0.5rem",
            }}
            onClick={goToNextWeek}
          />
        </div>
        {/* Display User Schedule */}
        <div
          className="mt-0 p-0 mb-0 calendar-view-box-schedule-2 border-schedule"
          style={{ minWidth: "1000px" }}
        >
          <div
            style={{
              minWidth: "259px",
              font: "normal normal normal 12px/17px Manrope",
              letterSpacing: "0px",
              color: "#707070",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Total Working Workers */}
            {t("Total Working Workers")}
          </div>
          <div
            style={{
              paddingRight: "0.5rem",
            }}
          >
            {""}
          </div>
          {allDays.map((day) => {
            const dayName = day.format("dddd").toLowerCase();
            const workersCount = memberListData.filter((user) => {
              return (
                user.userdetails[0]?.usersLogtimer &&
                user.userdetails[0]?.usersLogtimer.some(
                  (log) => log[dayName] && parseInt(log[dayName]) > 0,
                )
              );
            }).length;

            return (
              <div className="d-flex gap-3 schedule-wrp justify-content-center">
                <section style={{ fontSize: "14px", marginRight: "0.5rem" }}>
                  {workersCount}
                </section>
              </div>
            );
          })}
        </div>
        {showLoader ? (
          <div
            className="text-center"
            style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
          >
            <Loader />
          </div>
        ) : (
          <div className="schedule-list" style={{ minWidth: "1000px" }}>
            {filteredMembers.length > 0 ? (
              filteredMembers?.map((user, userIndex) => (
                <div
                  key={userIndex}
                  className="m-0 p-0 calendar-view-box-schedule-2"
                >
                  <div
                    className="d-flex gap-2 align-items-center schedule-info"
                    style={{
                      minWidth: "250px",
                      borderTop: "thin dashed #A8ACB0",
                      padding: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      history.push(`/updat-member/${user?.userid}`)
                    }
                  >
                    {user.imageurl ? (
                      <img
                        src={user.imageurl}
                        alt=""
                        height="30px"
                        width="30px"
                        style={{ borderRadius: "50%" }}
                      />
                    ) : (
                      <div
                        style={{
                          background: "rgb(149, 167, 198)",
                          borderRadius: "50%",
                          color: "white",
                          width: "30px",
                          height: "30px",
                          textAlign: "center",
                          paddingTop: "3px",
                        }}
                      >
                        {user.lastname
                          ? user.firstname[0]?.toUpperCase() +
                            "" +
                            user.lastname[0]?.toUpperCase()
                          : user.firstname.slice(0, 2).toUpperCase()}
                      </div>
                    )}

                    <h3
                      style={{
                        font: "normal normal bold 14px/19px Manrope",
                        letterSpacing: "0px",
                        color: "#333333",
                        margin: "0",
                      }}
                    >
                      {user.firstname} {user.lastname}
                    </h3>
                  </div>
                  {[
                    "monday",
                    "tuesday",
                    "wednesday",
                    "thursday",
                    "friday",
                    "saturday",
                    "sunday",
                  ].map((day, index) => {
                    const hours =
                      user.userdetails[0]?.usersLogtimer?.[0]?.[day] || 0;
                    const selectedUser = user.userid;
                    const userTimeOff =
                      user.userdetails[0]?.usersLogtimer?.[0]?.usertimeoff ||
                      [];
                    const timeOffForDay = userTimeOff.find((timeOff) => {
                      const from = moment(timeOff.startingDate);
                      const to = moment(timeOff.lastDay);
                      const currentDay = moment()
                        .startOf("week")
                        .add(index, "days");
                      return currentDay.isBetween(from, to, "day", "[]");
                    });

                    moment.updateLocale("en", { week: { dow: 1 } });

                    const dayDate = moment().startOf("week").add(index, "days");
                    const dayWeekNumber = dayDate.week();

                    const isToday =
                      weekNumber == dayWeekNumber &&
                      moment()
                        .startOf("day")
                        .isSame(dayDate.startOf("day"), "day");

                    // Get previous day's data
                    const previousDay = [
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                      "sunday",
                    ][index - 1];
                    const previousHours =
                      index > 0
                        ? user.userdetails[0]?.usersLogtimer?.[0]?.[
                            previousDay
                          ] || 0
                        : 0;
                    const previousTimeOff =
                      index > 0
                        ? user.userdetails[0]?.usersLogtimer?.[0]?.usertimeoff?.find(
                            (timeOff) => {
                              const from = moment(timeOff.startingDate);
                              const to = moment(timeOff.lastDay);
                              const prevDay = moment()
                                .startOf("week")
                                .add(index - 1, "days");
                              return prevDay.isBetween(from, to, "day", "[]");
                            },
                          )
                        : null;

                    // Determine if borderLeft should be removed
                    const removeBorderLeft =
                      (previousHours > 0 || previousTimeOff) &&
                      (hours > 0 || timeOffForDay);
                    return (
                      <div
                        key={index}
                        className="d-flex gap-3 schedule-wrp justify-content-center"
                        style={{
                          cursor: "pointer",
                          marginTop: isToday ? "2px" : "",
                          background: isToday ? "#fafafa" : "",
                          padding: "2px 0",
                          borderTop: isToday ? "none" : "thin dashed #A8ACB0",
                          borderLeft:
                            !timeOffForDay && removeBorderLeft
                              ? "none"
                              : "thin dashed #A8ACB0",
                        }}
                        onClick={() => {
                          if (timeOffForDay) {
                            return;
                          } else if (hours === 0 || hours === "") {
                            openModal(day, selectedUser, "");
                          } else {
                            openModal(day, selectedUser, hours);
                          }
                        }}
                        onContextMenu={(e) => {
                          const selectedDayDate = moment()
                            .startOf("week")
                            .add(index, "days")
                            .format();
                          console.log("asc date", selectedDayDate);
                          setSelectedDate(selectedDayDate);

                          if (timeOffForDay) {
                            return;
                          } else if (hours !== 0 && hours !== "") {
                            e.preventDefault();
                            setSelectedUserId(selectedUser);
                            setOpenTimeOff(true);
                          }
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            background:
                              isToday && timeOffForDay
                                ? "#a5a5a5"
                                : timeOffForDay
                                  ? "#a5a5a5"
                                  : isToday && +hours > 0
                                    ? "#e4edfaff"
                                    : isToday
                                      ? "#fafafa"
                                      : +hours > 0
                                        ? "#e4edfaff"
                                        : "",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: timeOffForDay ? 7 : "",
                          }}
                        >
                          <section
                            style={{
                              color: timeOffForDay ? "white" : "#333333",
                            }}
                            className="time-off-wrapper"
                          >
                            {timeOffForDay
                              ? timeOffForDay.type
                              : +hours > 0
                                ? hours
                                : ""}
                          </section>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))
            ) : (
              <h5 className="d-flex justify-content-center w-100 p-3">
                {/* No users found.. */}
                {t("No users found..")}
              </h5>
            )}
          </div>
        )}
      </div>

      <Modal
        visible={isModalOpen}
        onCancel={closeModal}
        footer={null}
        width={"fit-content"}
        closeIcon={false}
        style={{ background: "#FAFAFA" }}
        className="schedule-modal"
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            background: "#FAFAFA",
          }}
        >
          <div className="d-flex w-100 justify-content-end mb-2">
            <img
              alt=""
              width={"20px"}
              className="cursor-pointer"
              src={xIcon}
              onClick={() => {
                closeModal();
              }}
            />
          </div>
          <p>
            {/* Co-Worker defined with <b>{"40"} hours</b> a week. */}
            {t("Co-Worker defined with 40 hours a week")}
          </p>
          <p>
            {/* Hours to assign to each day? */}
            {t("Hours to assign to each day?")}
          </p>
          <input
            type="number"
            value={inputValue}
            onChange={handleInputChange}
            style={{
              textAlign: "center",
              margin: "15px 0 20px",
              padding: "10px",
              fontWeight: "bold",
              width: "100%",
              border: "none",
              background: "white",
            }}
          />
          <div className="d-flex w-100 justify-content-center pb-3">
            <button
              style={{
                backgroundColor: "#003766",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                width: "fit-content",
              }}
              onClick={handleAssignClick}
            >
              {/* Assign */}
              {t("Assign?")}
            </button>
          </div>
        </div>
      </Modal>
      {openTimeOff && (
        <TimeOffEntryPopover
          open={openTimeOff}
          onClose={() => setOpenTimeOff(false)}
          addEntry={addNewEntry}
          usersList={FetchUserData}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          timeOffEntries={timeOffEntries}
          index={index}
          setIndex={setIndex}
          setTimeOffEntries={setTimeOffEntries}
          selectedDate={selectedDate}
        />
      )}
    </>
  );
};

export default Schedule;
